import { Box } from "rebass/styled-components";
import theme from "../styles/theme";

function Container({ children }: { children: JSX.Element }) {
  return <Box sx={theme.container}>{children}</Box>;
}

export default Container;
